const FETCH_MATCHUP_INITIATED = 'FETCH_MATCHUP_INITIATED';
const FETCH_MATCHUP_SUCCEEDED = 'FETCH_MATCHUP_SUCCEEDED';
const FETCH_MATCHUP_FAILED = 'FETCH_MATCHUP_FAILED';

export default {
  FETCH_MATCHUP_FAILED,
  FETCH_MATCHUP_INITIATED,
  FETCH_MATCHUP_SUCCEEDED,
};
